export class State {
  filter: any = null;
}
